const TECHNICAL_MESSAGES = [
  /^internal server error\.?$/i,
  /^something went wrong\.?$/i,
  /^execution failed\.?$/i,
  /^request failed with status code \d+$/i,
  /^failed to fetch decrypted test plan\.?$/i,
];

const VARIABLE_MISSING_USER_MESSAGE =
  'One or more variables in this test could not be resolved. Check Variables & Environment — ensure every referenced variable exists and has a value for the selected environment, then retry.';

export function sanitizeExecutionErrorMessage(raw) {
  const text = String(raw ?? '').trim();
  if (!text || TECHNICAL_MESSAGES.some((re) => re.test(text))) {
    return VARIABLE_MISSING_USER_MESSAGE;
  }
  return String(raw ?? '');
}
